import React from 'react';
import RegisterConnector from '@dietlabs/components/src/ApolloConnectors/Register/RegisterConnectorApollo';
import UserDataConnector from '@dietlabs/components/src/ApolloConnectors/UserData/UserDataConnectorApollo';
import DeveloperOptionsComponent from 'DeveloperOptions/DeveloperOptionsComponent';

const DeveloperOptionsContainer = () => {
    const serverEnv =
        process.env.REACT_APP_ENV || process.env.NODE_ENV || 'prod';

    if (serverEnv === 'prod') {
        return null;
    }

    return (
        <RegisterConnector>
            {({ ...registerAndActivateCoupon }) => (
                <UserDataConnector>
                    {({ ...userDataOnDemand }) => (
                        <DeveloperOptionsComponent
                            {...registerAndActivateCoupon}
                            {...userDataOnDemand}
                        />
                    )}
                </UserDataConnector>
            )}
        </RegisterConnector>
    );
};

export default DeveloperOptionsContainer;
